import ServicePage from "../components/ServicePage";

export default function SeoNovara() {
  return (
    <ServicePage
      seo={{
        title: "SEO a Novara | Posizionamento su Google per Attività Locali — Lumora",
        description:
          "SEO a Novara per farti trovare su Google dai clienti della tua zona: SEO locale, Google Business Profile, contenuti ottimizzati e report mensili chiari e onesti.",
        path: "/seo-novara",
      }}
      kicker="SEO locale · Novara"
      h1="SEO a Novara: fatti trovare su Google dai clienti della tua zona"
      lead="Quando qualcuno cerca la tua attività a Novara e provincia, deve trovare te e non il concorrente. La nostra SEO locale lavora su questo: ricerche geografiche, Google Maps, contenuti utili e un sito tecnicamente impeccabile. Con report mensili che capisci davvero, senza fumo."
      features={[
        "SEO locale mirata: ottimizziamo per le ricerche con nome della tua città e della tua zona, quelle che portano clienti veri.",
        "Google Business Profile curato: scheda completa, categorie corrette, foto e recensioni gestite per la tua attività.",
        "Sito tecnicamente a posto: velocità, struttura, titoli e dati strutturati che Google premia.",
        "Contenuti che rispondono alle domande dei tuoi clienti, scritti per le persone e ottimizzati per i motori.",
        "Dati veri da Google Search Console: posizioni, clic e impressioni, non promesse generiche.",
        "Report mensile chiaro: cosa è migliorato, cosa faremo il mese dopo, in un italiano comprensibile.",
      ]}
      priceTitle="SEO Growth: €199/mese, risultati mese dopo mese"
      priceDesc="La SEO non è un interruttore ma un percorso: i primi miglioramenti si vedono in poche settimane, i risultati solidi si costruiscono nei mesi. Il canone include audit, ottimizzazioni tecniche, contenuti e report. Nessun vincolo lungo: resti perché funziona."
      faqs={[
        {
          q: "In quanto tempo vedo i risultati della SEO?",
          a: "Per ricerche locali poco competitive i primi miglioramenti arrivano in poche settimane. Per parole più competitive servono mesi di lavoro costante: chi ti promette la prima pagina in una settimana non è onesto.",
        },
        {
          q: "Servono contenuti nuovi ogni mese?",
          a: "I contenuti freschi aiutano molto: con il piano SEO Growth pubblichiamo articoli ottimizzati e aggiorniamo le pagine esistenti in base a cosa cercano davvero i tuoi clienti.",
        },
        {
          q: "Come misurate i risultati?",
          a: "Con i dati reali di Google Search Console: posizioni medie, clic e impressioni, mese per mese. Niente metriche inventate.",
        },
      ]}
      related={[
        { path: "/creazione-siti-web-novara", label: "Creazione siti web a Novara" },
        { path: "/web-design-novara", label: "Web design a Novara" },
        { path: "/gestione-siti-web", label: "Gestione siti web" },
      ]}
    />
  );
}
